import type {MemexColumnDataType, SystemColumnId} from '../../../api/columns/contracts/memex-column'
import {BaseColumnModel} from '../abstract/base'

export class MilestoneColumnModel extends BaseColumnModel {
  declare readonly id: typeof SystemColumnId.Milestone
  declare readonly dataType: typeof MemexColumnDataType.Milestone
  declare readonly userDefined: false
}
